<template>
  <div class="max-racing-number">
    <div class="max-racing-result-title">{{$t("maxracing.Place_champ")}} @9.70</div>
    <Row class="max-racing-champion-number-container" type="flex">
      <new-bet-lot
        v-for="item in championOdd"
        class="max-racing-champion-number-betlot"
        gameType="max_racing"
        game="max-racing"
        :key="item"
        :champion-bet="item"
        :type="championOddGroup"
        :win="champ === item"
        :odd="odd(championOddGroup)"
        :game-data="gameData"
        :minutes-string="minutesString"
        :seconds-string="secondsString"
        :disallow-betting="disallowBetting"
        :stake-record-sum="stakeRecordSum(item)"
        @update-session-storage="onUpdateSessionStorage"
        size="small"
      />
    </Row>
    <div class="max-racing-number-section-divider"></div>
    <Row class="max-racing-number-container" type="flex">
      <new-bet-lot
        v-for="item in championBigSmall"
        class="max-racing-number-betlot"
        gameType="max_racing"
        game="max-racing"
        :key="item"
        :type="item"
        :win="cbs === item"
        :odd="odd(item)"
        :game-data="gameData"
        :minutes-string="minutesString"
        :seconds-string="secondsString"
        :disallow-betting="disallowBetting"
        :stake-record-sum="stakeRecordSum(item)"
        @update-session-storage="onUpdateSessionStorage"
      />
    </Row>
    <div class="max-racing-number-section-divider"></div>
    <Row class="max-racing-number-container" type="flex">
      <new-bet-lot
        v-for="item in championOddEven"
        class="max-racing-number-betlot"
        gameType="max_racing"
        game="max-racing"
        :key="item"
        :type="item"
        :win="coe === item"
        :odd="odd(item)"
        :game-data="gameData"
        :minutes-string="minutesString"
        :seconds-string="secondsString"
        :disallow-betting="disallowBetting"
        :stake-record-sum="stakeRecordSum(item)"
        @update-session-storage="onUpdateSessionStorage"
      />
    </Row>
    <div class="max-racing-number-section-divider-thirteen"></div>
    <div
      class="max-racing-result-title"
    >{{$t('maxracing.Place_sum_champ')}} + {{$t('maxracing.Runner_up')}}</div>
    <div class="max-racing-number-section-divider-thirteen"></div>
    <Row class="max-racing-number-container" type="flex">
      <new-bet-lot
        v-for="item in sumBSOE"
        class="max-racing-number-betlot"
        gameType="max_racing"
        game="max-racing"
        :key="item"
        :type="item"
        :win="crbs === item || croe === item"
        :odd="odd(item)"
        :game-data="gameData"
        :minutes-string="minutesString"
        :seconds-string="secondsString"
        :disallow-betting="disallowBetting"
        :stake-record-sum="stakeRecordSum(item)"
        @update-session-storage="onUpdateSessionStorage"
      />
    </Row>
    <div class="max-racing-number-section-divider"></div>
    <Row class="max-racing-number-container" type="flex">
      <new-bet-lot
        v-for="item in group"
        class="max-racing-number-betlot"
        gameType="max_racing"
        game="max-racing"
        :key="item"
        :type="item"
        :win="g === item"
        :odd="odd(item)"
        :game-data="gameData"
        :minutes-string="minutesString"
        :seconds-string="secondsString"
        :disallow-betting="disallowBetting"
        :stake-record-sum="stakeRecordSum(item)"
        @update-session-storage="onUpdateSessionStorage"
      />
    </Row>
  </div>
</template>

<script>
import { Row, Col, Button } from "iview";
import NewBetLot from "../../commons/NewBetLot";
import betLotMixin from "../../../mixins/bet-lot-mixin";

export default {
  mixins: [betLotMixin],
  props: ["winCellNo", "game", "gameData", "drawResult"],
  components: {
    Row,
    Col,
    Button,
    NewBetLot
  },
  data() {
    return {
      championOddGroup: "o1",
      championOdd: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      championBigSmall: ["o2", "o3"],
      championOddEven: ["o4", "o5"],
      sumBSOE: ["o6", "o7", "o8", "o9"],
      group: ["o10", "o11", "o12", "o13", "o14"],
      cbs: 0,
      coe: 0,
      crbs: 0,
      croe: 0,
      g: 0,
      champ: 0
    };
  },
  watch: {
    drawResult() {
      this.cbs = "o" + parseInt(this.drawResult.c_bs);
      this.coe = "o" + parseInt(this.drawResult.c_oe);
      this.crbs = "o" + parseInt(this.drawResult.cru_bs);
      this.croe = "o" + parseInt(this.drawResult.cru_oe);
      this.g = "o" + this.drawResult.group;

      if (this.drawResult.champion.charAt(0) == 1) {
        if (this.drawResult.champion.charAt(1) == 0) {
          this.champ = 10;
        } else {
          this.champ = 1;
        }
      } else {
        this.champ = parseInt(this.drawResult.champion.charAt(0));
      }
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.max-racing-number {
  @extend .game-section;
}

.max-racing-result-title {
  display: flex;
  justify-content: center;
  width: 100%;
  background: #1c3a67;
  font-weight: bold;
  color: white;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  font-weight: 500;
}

.max-racing-result-container {
  display: flex;
  padding: 5px;
  margin: 5px;
}

.max-racing-number-container {
  padding: 6px;
  background: #e5eaf8;
  border-radius: 5px;
}

.max-racing-champion-number-container {
  margin: 12px 8px;
}
.max-racing-number-section-divider {
  height: 5px;
}
.max-racing-number-section-divider-thirteen {
  height: 13px;
}

.max-racing-number-betlot {
  position: relative;
  flex: 1;
  margin: 0 2px;
}

.max-racing-champion-number-betlot {
  position: relative;
  font-size: 11px;
  font-weight: bold;
  height: 22px;
  width: 22px;
  cursor: pointer; //1017 ADDED
}

.max-racing-champion-number-container.ivu-row-flex {
  justify-content: space-between;
}

.max-racing-number-betlot:first-of-type {
  margin-left: unset;
}

.max-racing-number-betlot:last-of-type {
  margin-right: unset;
}

.max-racing-number-cell {
  position: relative;
  padding: 0;
  flex: 3.42857143;
  padding-top: 6px;
  padding-bottom: 6px;
}

.max-racing-number-cell:first-of-type {
  margin-left: unset;
}

.max-racing-number-cell:last-of-type {
  margin-right: unset;
}

.max-racing-number-title {
  @extend .tai-xiu-game-title;
}

.max-racing-number-bet-no {
  @extend .tai-xiu-game-bet-no;
  margin-top: unset;
}

.max-racing-number-cell.ivu-btn:before {
  content: "";
  display: block;
  top: 0;
  height: 31%;
  z-index: 0;
}

@media only screen and (max-width: 360px) {
  .max-racing-number-bet-no {
    margin-top: 5px;
    font-size: 12px;
  }
}
</style>

<style lang="scss">
.max-racing-number-cell.ivu-btn {
  @extend .tai-xiu-game-btn;
}

.max-racing-number-cell.ivu-btn:hover .max-racing-number-title,
.max-racing-number-cell.ivu-btn:hover .max-racing-number-bet-no {
  @extend .tai-xiu-game-btn-hover-cell;
}

.max-racing-number-cell.ivu-btn:focus {
  @extend .tai-xiu-game-btn-focus;
}

.max-racing-number-cell.max-racing-number-cell-active.ivu-btn
  .max-racing-number-title,
.max-racing-number-cell.max-racing-number-cell-active.ivu-btn
  .max-racing-number-bet-no {
  @extend .tai-xiu-game-btn-active;
}

.max-racing-number-cell.ivu-btn:hover {
  @extend .tai-xiu-game-btn-hover;
}
</style>
